var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"statusFixo":_vm.statusFixo,"statusModal":_vm.statusModal},on:{"changeTipo":_vm.changeTipo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }